import React, { forwardRef } from 'react';
import { cn } from '../../lib/utils';
export interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  error?: string;
  helperText?: string;
}
const Input = forwardRef<HTMLInputElement, InputProps>(({
  className,
  type,
  label,
  error,
  helperText,
  ...props
}, ref) => {
  return <div className="w-full space-y-2" data-id="element-274">
        {label && <label className="text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70 text-slate-700" data-id="element-275">
            {label}
          </label>}
        <input type={type} className={cn('flex h-10 w-full rounded-md border border-slate-300 bg-white px-3 py-2 text-sm ring-offset-white file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-slate-500 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#218080] focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50', error && 'border-red-500 focus-visible:ring-red-500', className)} ref={ref} {...props} data-id="element-276" />
        {helperText && !error && <p className="text-xs text-slate-500" data-id="element-277">{helperText}</p>}
        {error && <p className="text-xs font-medium text-red-500" data-id="element-278">{error}</p>}
      </div>;
});
Input.displayName = 'Input';
export { Input };